// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/dietz-gmbh-unter-der-rubrik-coburgs-beste-neu-im-coburger-magazin/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const dietzGmbhUnterDerRubrikCoburgsBesteNeuImCoburgerMagazinDE: PageEntry = {
  id: "post.dietz-gmbh-unter-der-rubrik-coburgs-beste-neu-im-coburger-magazin",
  locale: "de",
  slug: "dietz-gmbh-unter-der-rubrik-coburgs-beste-neu-im-coburger-magazin",
  seo: {
    title: "Dietz GmbH unter der Rubrik „Coburgs Beste“ – neu im COBURGER Magazin | Dietz GmbH",
    description: "Dietz GmbH unter der Rubrik „Coburgs Beste“ – neu im COBURGER Magazin",
  },
  type: "post",
  h1: "Dietz GmbH unter der Rubrik „Coburgs Beste“ – neu im COBURGER Magazin",
  blocks: [
    { kind: "heading", level: 2, text: "Dietz GmbH unter der Rubrik „Coburgs Beste“ – neu im COBURGER Magazin" },
    { kind: "paragraph", text: "Coburgs Beste sind Unternehmen, die sich durch die Kombination verschiedener Kriterien auszeichnen: Durch hohen Innovationsgrad verbunden mit einer mehrjährigen Unternehmenstradition, durch eine gute Ausbildungsquote, und vor allem durch die enge Verbundenheit zur Heimatregion Coburg. In der Dezember Ausgabe wurde unser Unternehmen unter der neuen Rubrik „Coburgs Beste“ des COBURGER Magazins vorgestellt." }
  ],
};
